var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{style:(_vm.styles),attrs:{"rounded":"","depressed":"","small":"","color":_vm.color,"loading":_vm.loading,"disabled":_vm.loading || _vm.disabled,"block":_vm.block},on:{"click":function($event){return _vm.$emit(_vm.emit)}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_vm.icon))]),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }